"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cornaredo": {
    "af6b87e0": [{
      "hkey": "a0d3ad25",
      "slug": "cornaredo",
      "name": "Cornaredo",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-torrette": [{
      "hkey": "a0d3ad25",
      "slug": "cornaredo",
      "name": "Cornaredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "00dd1914": [{
      "hkey": "a0d3ad25",
      "slug": "cornaredo",
      "name": "Cornaredo",
      "primary": true,
      "skipSearch": false
    }],
    "favaglie": [{
      "hkey": "a0d3ad25",
      "slug": "cornaredo",
      "name": "Cornaredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;